export function onScrollEnd(targetEl, scrollEndFn = function(){}, timeout = 1000) {
    let notDeal = [],
        wait2Deal = [],
        timerId = null;

    [].slice.call(targetEl).forEach((el, index) => {
        notDeal[index] = el
    })

    window.addEventListener('scroll', function (e) {
        if (timerId) {
            clearTimeout(timerId)
        }
        timerId = setTimeout(function () {
            notDeal.forEach((el, index) => {
                let rect = el.getBoundingClientRect();
                if (!el.__yused && rect.top > 0 && rect.bottom < window.innerHeight) {
                    wait2Deal.push({el:notDeal[index], index})
                    el.__yused = true
                }
            })
            // wait2Deal.forEach(scrollEndForEachFn)
            scrollEndFn(wait2Deal)
            wait2Deal = []
        }, timeout)
        
    })
    // window.scrollTo(0, 1)
}

export function aLinkOpen(url) {
    let el = document.createElement('a');
    document.body.appendChild(el);
    el.href = url;
    el.target = '_new';
    el.click();
    document.body.removeChild(el);
};


export function match(el, selector) {
    const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector
    return matchesSelector.call(el, selector)
}

let _tip = null,
    _tipTimer = null
export function showTip(text, time = 1500, ext = {}) {

    if (_tip) {
        _tip.innerText = text
        _tip.style['pointer-events'] = 'all'
        _tip.style.opacity = 1
    } else {
        _tip = document.createElement('div')
        _tip.className = 'kb-tip'
        _tip.innerText = text
        ext.style && _tip.setAttribute('style', ext.style)
        document.body.appendChild(_tip)
    }

    if (_tipTimer) {
        clearTimeout(_tipTimer)
    }

    _tipTimer = window.setTimeout(() => {
        _tip.style.opacity = 0
        _tip.style['pointer-events'] = 'none'
        _tipTimer = null
    }, time)
}

export function onScrollEndExposure(targetEl, scrollEndFn = function(){}, timeout = 1000) {
    let notDeal = [],
        wait2Deal = [],
        timerId = null;

    [].slice.call(targetEl).forEach((el, index) => {
        notDeal[index] = el
    })

    function checkExposure(){
        notDeal.forEach((el, index) => {
            if (!el.__yused && el.offsetTop > window.scrollY && el.offsetTop < window.scrollY + window.innerHeight) {
                // console.log(el.offsetTop, window.scrollY + window.innerHeight)
                wait2Deal.push({el:notDeal[index], index})
                el.__yused = true
            }
        })
        scrollEndFn(wait2Deal)
        wait2Deal = []
    }


    window.addEventListener('scroll', function (e) {
        if (timerId) {
            clearTimeout(timerId)
        }
        timerId = setTimeout(function () {
            checkExposure()
        }, timeout)
    })
    checkExposure()
}